import { toast } from 'react-toastify';
import { css } from 'glamor';

const displayError = (message) => {
  return dispatch => {
    if (message) {
      const options = {
        position: "bottom-center",
        type: 'error',
        autoClose: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: css({
          borderRadius: '5px',
          padding: '20px',
        }),
      }
      toast(message, options);
    }
  }
}

const displayInfo = (message) => {
  return dispatch => {
    if (message) {
      const options = {
        position: "bottom-center",
        type: 'info',
        autoClose: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: css({
          borderRadius: '5px',
          padding: '15px',
          backgroundColor: '#1dc2ff',
        }),
      }
      toast(message, options);
    }
  }
}

const displaySuccess = (message) => {
  return dispatch => {
    if (message) {
      const options = {
        position: "bottom-center",
        type: 'success',
        autoClose: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: css({
          borderRadius: '5px',
          padding: '20px',
        }),
      }
      toast(message, options);
    }
  }
}



export default {
  displayError,
  displayInfo,
  displaySuccess,
}
